/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { getProp, safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        typographyProps: {
            size: 12,
            lineHeight: "26px",
            weight: 600,
            ellipsis: true,
        },
        css: css`
            &&& {
                margin: 10px auto;

                a {
                    span {
                        color: ${getColor("common.ui23")};
                        font-weight: 400;
                    }

                    &:hover,
                    &:focus {
                        span {
                            color: ${props => safeColor(props.theme.colors.common.ui23).darken(0.9).hex().toString()};
                        }
                    }
                }

                .breadcrumbs-overflow {
                    position: relative;
                    cursor: pointer;
                    z-index: ${getProp("theme.zIndex.default")};

                    &:after {
                        content: "...";
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translateY(-50%);
                        color: ${getColor("common.ui23")};
                    }

                    .breadcrumbs-overflow-items {
                        opacity: 0;
                        pointer-events: none;
                        background: ${getColor("common.background")};
                        box-shadow: ${getProp("theme.shadows.3")};
                        padding: 10px;
                        border-radius: 4px;
                        overflow: hidden;
                        min-width: 190px;
                        position: absolute;
                        top: 100%;
                        left: 0;
                        transition: all 0.2s ease;

                        > span {
                            display: none;
                        }

                        > a {
                            width: 100%;
                            padding-left: 5px;
                            transition: all 0.2s linear;

                            &:hover,
                            &:focus {
                                background: ${getColor("common.ui21")};
                            }
                        }
                    }

                    &:hover,
                    &:focus {
                        .breadcrumbs-overflow-items {
                            opacity: 1;
                            pointer-events: all;
                        }
                    }
                }

                @media print {
                    display: none;
                }
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
